<template>
    <div>
      <jet-dialog-modal :show="true">
        <template #title>
          <div class="flex justify-between items-center">
          <h2 class="sm:pt-4 pt-2 lg:text-2xl sm:text-lg text-sm">
            Offering
          </h2>
          <jet-secondary-button @click="closeModel" class="cursor-pointer pt-4">Close</jet-secondary-button></div>
          <div class="flex flex-wrap justify-between items-center float-right">

          </div>
        </template>

        <template #content>
            <TableIndexLayout>
                <div class="-my-2">
                    <div class="py-2 align-middle inline-block w-full overflow-auto">
                    <div class="">
                    <TableIndexLayout>
                        <div class="-my-2">
                        <div class="py-2 align-middle inline-block w-full overflow-auto">
                            <div class="shadow overflow-x-auto max-height h-screen-95">
                            <table class="min-w-full">
                                <thead class="header-bg-color">
                                <tr>
                                    <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-base
                                        font-bold
                                        text-black-800
                                        uppercase
                                        tracking-wider
                                    "
                                    >
                                    SITE
                                    </th>
                                    <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-base
                                        font-bold
                                        text-black-800
                                        uppercase
                                        tracking-wider
                                    "
                                    >
                                    MEAL TYPE
                                    </th>
                                    <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-base
                                        font-bold
                                        text-black-800
                                        uppercase
                                        tracking-wider
                                    "
                                    >AGE</th>

                                    <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-base
                                        font-bold
                                        text-black-800
                                        uppercase
                                        tracking-wider
                                    "
                                    >STATUS</th>

                                </tr>
                                </thead>
                                <tbody>

                                <tr v-for="offeringData in offeringData " class="bg-white">
                                    <td
                                    class="
                                        px-6
                                        py-4
                                        whitespace-nowrap
                                        text-base text-color
                                    "
                                    >
                                    {{ offeringData.offeringname }}
                                    </td>
                                    <td
                                    class="
                                        px-6
                                        py-4
                                        whitespace-nowrap
                                        text-base text-color
                                    "
                                    >
                                    {{ offeringData.mealtype }}

                                    </td>
                                    <td
                                    class="
                                        px-6
                                        py-4
                                        whitespace-nowrap
                                        text-base text-color
                                    "
                                    >
                                    {{ offeringData.age }}

                                    </td>

                                    <td
                                    class="
                                        px-6
                                        py-4
                                        whitespace-nowrap
                                        text-base text-color
                                    "
                                    >
                                    <div class="flex items-center">
                                    <svg v-if="offeringData.status" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="#cb0000"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>

                                    {{ offeringData.status ? 'Awaiting Count' : 'Ready' }}
                                    </div>

                                    </td>


                                </tr>

                                <!-- Odd row -->
                                <tr class="bg-white" v-if="offeringData.length == 0">
                                    <td
                                    class="
                                        px-6
                                        py-4
                                        whitespace-nowrap
                                        text-base text-color text-center
                                    "
                                    colspan="4"
                                    >
                                    Loading......
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                        </div>
                    </TableIndexLayout>
                </div>
              </div>
            </div>
            </TableIndexLayout>
        </template>

        <template #footer>
          <jet-secondary-button @click="closeModel" class="cursor-pointer">Close</jet-secondary-button>
        </template>
      </jet-dialog-modal>
    </div>
  </template>

  <script>
  import vClickOutside from "click-outside-vue3";
  import JetDialogModal from "@/Jetstream/DialogModal";

  export default {
    directives: {
      clickOutside: vClickOutside.directive,
    },

    props: ["cartDate", "site"],

    components: {
      vClickOutside,
      JetDialogModal,
    },

    data() {
      return {
        offeringData:[],
      };
    },

    methods: {
      showsSiteData() {
        console.log("cartDate", this.cartDate, "site", this.site);

        axios
         .post("/offering-data-by-cart-date", {
               site_id: this.site,
               order_date: this.cartDate,
          })
          .then((response) => {
            // this.form.site = site;
            // console.log('offeringDataa');
            // console.log(response.data.data);
            this.offeringData = response.data.data;

          })
          .catch((error) => console.error(error));
        console.log("showsSiteData");
      },

      // onClickOutside(event) {
      //   this.is_show = 0;
      //   this.$emit('closeModal');
      // },

      closeModel(){
        this.$emit('closeModal');
      },

    }
  };
  </script>
  <style>
  .h-screen-95{
  height: 60vh;
  }
  </style>
